import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/feature/SectionTitle';
import { featuredTopics } from '@/mocks/topics';

export default function FeaturedTopics() {
  return (
    <section id="topics" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="Editor's Picks"
            title="专题合辑 · 把零散条目串成线索"
            desc="编辑按主题整理的长线合辑，标题优先、配图克制，方便按一条线索把相关更新一次看全。"
            action={{ label: '全部合辑', href: '#overview' }}
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {featuredTopics.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300">
                <div className="h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={topic.image}
                    alt={`${topic.title} 专题合辑配图`}
                    title={`${topic.title} · 黑料一区专题合辑`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between">
                    <span className="rounded-full bg-accent-100 px-3 py-1 text-[11px] text-accent-900 whitespace-nowrap">{topic.tag}</span>
                    <span className="font-label text-[11px] text-foreground-500">{topic.count} 条</span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {topic.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="text-[11px] text-foreground-500">{topic.updated}</span>
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap">
                      进入合辑
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}